
import { Component, Prop, Vue } from 'vue-property-decorator';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import Business from '../models/Business';
import AnOverline from '../components/AnOverline.vue';
import BusinessTestimony from './BusinessTestimony.vue';

@Component({
  components: { AnOverline, BusinessTestimony, MediaImg },
})
export default class extends Vue {
  @Prop(Object) readonly business!: Business;

  get coverImageId() {
    return this.business?.coverImage?.id;
  }

  get asideImageId() {
    return this.business?.asideImage?.id;
  }
}
